import { useQuery } from '@tanstack/vue-query';
import { computed, ref } from 'vue';
import { getRole } from '@infuse/api/iam/role';
import { Role } from '@infuse/iam/role/type';
import { getOrganisationRole } from '@infuse/api/iam/organisation';
import { getTenantRole } from '@infuse/api/iam/tenant';

export const useRole = () => {
  const fetchRoleId = ref<string | undefined>(undefined);
  const levelType = ref<string | undefined>(undefined);
  const levelId = ref<string | undefined>(undefined);

  const query = useQuery<Role>({
    queryKey: ['roles', 'detail', fetchRoleId, levelType, levelId],
    enabled: () => !!fetchRoleId.value && (!levelType.value || !!levelId.value),
    queryFn: () => {
      if (levelType.value && levelId.value && levelType.value === 'organisation') {
        return getOrganisationRole({ roleId: fetchRoleId.value, id: levelId.value });
      }

      if (levelType.value && levelId.value && levelType.value === 'tenant') {
        return getTenantRole({ roleId: fetchRoleId.value, id: levelId.value });
      }

      return getRole({ id: fetchRoleId.value });
    }
  });

  const role = computed(() => query.data.value);

  return {
    ...query,
    role,
    fetchRoleId,
    levelType,
    levelId
  };
};
